import * as React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom-v5-compat';

import ByStudent from './by_student'
import ByStandard from './by_standard'

import { ALL_PRACTICE, NO_CLASSROOM, renderNoClassroomEmptyState, } from '../../shared/shared'
import { ClassroomInterface, SkillCategoryInterface, StudentPerformanceData, StateStandardPerformanceData, StateStandardInterface } from '../interfaces';
import { useReportPremiumContext } from '../../shared/report_premium_context';
import {
  Spinner,
} from '../../../../../Shared/index';

interface SmartGroupsProps {
  classroom: ClassroomInterface;
  filteredSkillCategories: SkillCategoryInterface[];
  filteredStateStandards: StateStandardInterface[];
  handleAssignTargetedPracticeClick: (skillId: number, studentIds: number[], smartGroup?: string) => void;
  includeELL: boolean;
  momentumScoreGoal: number;
  onSkillCategoryClick: (skillCategoryId: number) => void;
  practiceScope: string;
  renderHeader: (title: string) => React.ReactNode;
  renderNeedsVerificationEmptyState: () => React.ReactNode;
  renderUpgradeEmptyState: () => React.ReactNode;
  renderVerificationBanner: () => React.ReactNode;
  selectedGradeLevel?: string;
  selectedSkillCategoryId: any;
  selectedStateStandardId: any;
  selectedStudentId: any;
  stateStandardsData: {[key: string]: StateStandardPerformanceData[]};
  stateStandardsDataKey: string;
  studentData: {[key: string]: StudentPerformanceData[]};
  studentDataKey: string;
  userNeedsVerification: boolean;
}

const SmartGroups: React.FC<SmartGroupsProps> = ({
  classroom,
  filteredSkillCategories,
  filteredStateStandards,
  handleAssignTargetedPracticeClick,
  includeELL,
  momentumScoreGoal,
  onSkillCategoryClick,
  practiceScope,
  renderHeader,
  renderNeedsVerificationEmptyState,
  renderUpgradeEmptyState,
  renderVerificationBanner,
  selectedGradeLevel,
  selectedSkillCategoryId,
  selectedStateStandardId,
  selectedStudentId,
  stateStandardsData,
  stateStandardsDataKey,
  studentData,
  studentDataKey,
  userNeedsVerification,
}) => {
  const { hasSchoolOrDistrictPremium } = useReportPremiumContext();
  const location = useLocation();

  const byStudent = location.pathname.includes('by_student');

  const selectedSkillCategory = filteredSkillCategories.find(skillCategory => skillCategory.id === selectedSkillCategoryId)
  const selectedStateStandard = filteredStateStandards.find(stateStandard => stateStandard.id === selectedStateStandardId)

  const sharedProps = {
    classroom,
    handleAssignTargetedPracticeClick,
    includeELL,
    momentumScoreGoal,
    onSkillCategoryClick,
    practiceScope,
    selectedSkillCategory,
  }

  const routes = (
    <Routes>
      <Route
        element={
          <ByStudent
            {...sharedProps}
            data={studentData[studentDataKey]}
            selectedStateStandard={selectedStateStandard} 
          />
        }
        path="by_student"
      />
      <Route
        element={
          <ByStandard
            {...sharedProps}
            data={stateStandardsData[stateStandardsDataKey]}
            selectedGradeLevel={selectedGradeLevel}
            studentId={selectedStudentId}
          />
        }
        path="by_standard"
      />
    </Routes>
  )

  if (!classroom || (byStudent && filteredStateStandards.length && !selectedStateStandard)) { return <Spinner /> }

  function renderContent() {
    if (!hasSchoolOrDistrictPremium && practiceScope === ALL_PRACTICE) {
      return renderUpgradeEmptyState()
    }
    
    if (userNeedsVerification && practiceScope === ALL_PRACTICE) {
      return renderNeedsVerificationEmptyState()
    }

    if (classroom.id === NO_CLASSROOM.id) {
      return renderNoClassroomEmptyState()
    }

    return routes
  }

  return (
    <main className="smart-groups">
      {renderHeader('Smart Groups')}
      {renderVerificationBanner()}
      <div className="smart-groups-content">
        {renderContent()}
      </div>
    </main>
  );
};

export default SmartGroups;
